/* PureState review grid (sections/ps-reviews-real.liquid, the Grüns-pattern group): chip filtering only.
   The cards are server-rendered, so this file just shows and hides them and keeps the chip state in sync.
   Card category/tags come from the same data attributes snippets/ps-review-card already writes, so section II
   and section VIII filter identically. No Romanian literals: every label is rendered by the section. */
(function () {
  'use strict';
  if (customElements.get('ps-reviews-grid')) return;

  function parseList(v) {
    return String(v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  customElements.define('ps-reviews-grid', class extends HTMLElement {
    connectedCallback() {
      this.allKey = this.dataset.allKey || 'all';
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-ps-chips] [data-key]'));
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-ps-grid] > *'));
      this.empty = this.querySelector('[data-ps-grid-empty]');
      if (!this.chips.length || !this.cards.length) return;

      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
      this.apply(this.allKey);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick(e) {
      var chip = e.target && e.target.closest && e.target.closest('[data-ps-chips] [data-key]');
      if (!chip || !this.contains(chip)) return;
      e.preventDefault();
      this.apply(chip.dataset.key || this.allKey);
    }

    /* The grid child is usually the <li>; ps-review-card puts data-category / data-tags on the <article>
       inside it. Read whichever carries the attribute, without relying on Element.matches — the grid can
       hold nodes (an app block's wrapper, an <svg>) that do not implement it. */
    holder(card) {
      if (card && card.getAttribute && card.getAttribute('data-category') !== null) return card;
      return card && card.querySelector ? card.querySelector('[data-category]') : null;
    }

    matches(card, key) {
      if (key === this.allKey) return true;
      var a = this.holder(card);
      if (!a) return false;
      if ((a.getAttribute('data-category') || '') === key) return true;
      return parseList(a.getAttribute('data-tags')).indexOf(key) !== -1;
    }

    apply(key) {
      var self = this;
      var shown = 0;
      this.cards.forEach(function (card) {
        var on = self.matches(card, key);
        card.hidden = !on;
        if (on) shown += 1;
      });
      this.chips.forEach(function (c) {
        var on = (c.dataset.key || self.allKey) === key;
        c.classList.toggle('is-active', on);
        if (c.hasAttribute('aria-pressed')) c.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (c.getAttribute('role') === 'tab') c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (this.empty) this.empty.hidden = shown > 0;
    }
  });
})();
